import {
  NextMonthMasterclassDocument,
  NextMonthMasterclassQuery,
} from '@/generated/graphql'
import { graphqlRequest } from '@/lib/serverSideClient'

export const classNames = (
  ...classes: (string | Record<string, boolean>)[]
) => {
  return classes
    .filter(Boolean)
    .map(cls => {
      if (typeof cls === 'string') {
        return cls
      }
      return Object.entries(cls)
        .filter(([_, value]) => value)
        .map(([className]) => className)
        .join(' ')
    })
    .join(' ')
}

export const getNextMonthAndYear = () => {
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth() // 0-11
  const nextMonthDate = new Date(currentDate.getFullYear(), currentMonth + 1, 1)
  return {
    month: nextMonthDate.getMonth() + 1, // Convert to 1-12
    year: nextMonthDate.getFullYear(),
  }
}

export const getNextMasterClassMonthAndYearToDisplay = () => {
  return getNextMonthAndYear()
}

export async function getMasterclass(
  month: number,
  year: number
): Promise<NextMonthMasterclassQuery['masterclassByMonthAndYear']> {
  const data = await graphqlRequest<NextMonthMasterclassQuery>(
    NextMonthMasterclassDocument,
    { month, year }
  )

  return data.masterclassByMonthAndYear
}
export const getCountryFlag = (
  code?: string | null,
  brandCode?: string | null
) => {
  if (!!code) {
    // Try direct ISO code first, then check currency mapping
    const countryCode = code.toUpperCase()
    if (!countryCode) return ''

    // Convert country code to flag emoji
    return Array.from(countryCode)
      .map(char => String.fromCodePoint(char.charCodeAt(0) + 127397))
      .join('')
  } else if (brandCode === 'VANISHING_INC_UK') {
    return Array.from('GB')
      .map(char => String.fromCodePoint(char.charCodeAt(0) + 127397))
      .join('')
  } else if (brandCode === 'VANISHING_INC_US') {
    return Array.from('US')
      .map(char => String.fromCodePoint(char.charCodeAt(0) + 127397))
      .join('')
  } else {
    return ''
  }
}

export function slugifyString(name: string): string {
  return (
    name
      // normalise accented letters to plain ASCII (NFKD breaks chars into base + diacritics)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '') // drop the diacritics
      // keep letters, digits, spaces, and hyphens only
      .replace(/[^a-zA-Z0-9\s-]/g, '')
      // convert runs of whitespace to a single hyphen
      .trim()
      .replace(/\s+/g, '-')
      // collapse any repeated hyphens
      .replace(/-+/g, '-')
      // final lower-case
      .toLocaleLowerCase('en-GB')
  )
}
